import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Impressum from './Impressum';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-cyan-500/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center space-y-6">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_violet-shield-1/artifacts/vq6spdqy_Scanfire-300x93.png" 
              alt="Scanfire Logo" 
              className="h-12 w-auto"
            />
          </div>

          {/* Tagline */}
          <p className="text-gray-400 text-center max-w-2xl">
            {t.footer.tagline}
          </p>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm text-gray-500">
            <span>© {currentYear} Scanfire</span>
            <span className="w-1 h-1 bg-gray-600 rounded-full" />
            <a href="#" className="hover:text-cyan-400 transition-colors duration-200">
              {t.footer.privacy}
            </a>
            <span className="w-1 h-1 bg-gray-600 rounded-full" />
            <Impressum />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
